/* eslint-disable no-underscore-dangle */

import Renderer from './device-capture-status-renderer';

const _ = require('lodash');
const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

class DeviceCaptureStatusColumnComponent extends DefaultColumnComponent {
  constructor(value) {
    super(value);
    this._value = value;
    this._renderer = new Renderer(this);
    this._registerListeners();
  }

  /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this.setCaptureStatus(newVal);
    }
  }

  getValue() {
    return this.getCaptureStatus();
  }

  setCaptureStatus(newVal) {
    this._value = newVal;
    this.emit('CaptureStatus', newVal);
    return this;
  }

  getCaptureStatus() {
    return this._value;
  }

  /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

export default DeviceCaptureStatusColumnComponent;
